<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html,body,#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  margin-top: 0px;
  height: 100%;
}
* {
  padding: 0px;
  margin: 0px;
}
/* .el-form-item {
  margin-bottom: 12px;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue